module.exports = "./img/21ae5ef7ea7666f015a80a423b475530.jpg";